import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RotateCcw, Loader2 } from 'lucide-react';
import { getCookie } from '../utils/csrf';
import { fetchWithRetry } from '../utils/api';

const ReturningLeagueSelector = () => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchWithRetry('/api/distinct-leagues-previous/', {}, 3)
      .then((res) => res.json())
      .then((data) => setLeagues(data))
      .catch((err) => console.error('Error fetching distinct leagues:', err));
  }, []);

  const handleSelect = async (e) => {
    const leagueId = e.target.value;
    if (!leagueId) return;

    setLoading(true);
    setError('');
    try {
      const csrftoken = getCookie('csrftoken');
      const response = await fetchWithRetry(
        `/api/copy-old-league/${leagueId}/`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrftoken },
          credentials: 'include',
        },
        2
      );
      const data = await response.json();
      if (response.ok && data.redirect_url) {
        navigate(data.redirect_url);
      } else {
        setError(data.error || 'Failed to copy league.');
      }
    } catch {
      setError('An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  if (leagues.length === 0) return null;

  return (
    <div className="mb-6 bg-ds-white border border-border-card rounded-card p-5 border-l-[5px] border-l-green-mid">
      <div className="flex items-center gap-2 mb-3">
        <RotateCcw className="w-4 h-4 text-green-mid shrink-0" />
        <span className="font-display text-base font-bold text-ds-text">
          Returning for the new season?
        </span>
      </div>
      <p className="text-text-muted text-xs font-semibold mb-3">
        Select a previous league to automatically add it for the current season.
      </p>

      <div className="flex min-w-0 items-center gap-3">
        <select
          defaultValue=""
          onChange={handleSelect}
          disabled={loading}
          className="w-full min-w-0 border border-border rounded-lg px-3 py-2 text-sm text-ds-text focus:outline-none focus:border-green bg-ds-white disabled:opacity-60"
        >
          <option value="">— Select a league —</option>
          {leagues.map((l) => (
            <option key={`${l.league_id}-${l.league_year}`} value={l.league_id}>
              {l.league_year} · {l.league_name} ({l.league_id})
            </option>
          ))}
        </select>
        {loading && <Loader2 className="w-4 h-4 text-green animate-spin" />}
      </div>

      {error && <p className="mt-2 text-coral text-xs font-semibold">{error}</p>}
    </div>
  );
};

export default ReturningLeagueSelector;
